export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Logga in",
    "login.form.hint.user": "Inloggning",
    "login.form.hint.password": "Lösenord",
    "login.form.checkbox.remember-me": "Kom ihåg mig",
    "login.form.button.sign-in": "Logga in",
    "login.form.message.invalid-user-credentials": "Inloggning eller lösenord är felaktigt",
    "login.form.message.user-required": "Ange inloggning",
    "login.form.message.password-required": "Ange ett lösenord",
    "login.form.button.forgot-password": "Glömt lösenordet?",
    "error.root-admin-login.title": "Fel 403- förbjudet",
    "error.root-admin-login.message": "Du är inloggad som skrivskyddad administratör. För att få åtkomst till Web Recovery-konsolen loggar du istället in som kundklient-användare eller administratör"
};
